import { BASE_URL, PUBLIC, PUBLIC_CONTACT_US } from "../common/URLs"

const url = `${BASE_URL}/${PUBLIC}/${PUBLIC_CONTACT_US}`

export const addContactUsPublic = async (newContactUs) => {
    try {

        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",

            },
            body: JSON.stringify(newContactUs),

        })
        return await response.json()
    } catch (error) {
        console.error("Add error:", error);
        throw error;
    }
}

